module.exports = __webpack_public_path__ + "assets/img/callum_croom.f2d04944.png";